import { useParams } from 'react-router'

import type { EntityParams } from '../types/entity'

type Return = { ownerId: string; tenantId: string }

export function useEntityParams({
  isOptional,
}: {
  isOptional: true
}): Partial<Return>
export function useEntityParams(): Return
export function useEntityParams(options?: Record<string, unknown>) {
  const { ownerId, tenantId } = useParams<EntityParams>()

  if (options?.['isOptional']) {
    return { ownerId, tenantId }
  }

  if (ownerId && tenantId) {
    return { ownerId, tenantId }
  } else {
    throw new Error(
      `Unable to get parameter: ${!ownerId ? 'ownerId' : 'tenantId'}`,
    )
  }
}
